import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import { AnalizyRatingState, ProductDetailConfiguration } from '@types';
import { OverviewComponentConfig } from '../overview-component.config';
import { OverviewDisplayComponent } from '../overview-display-component.interface';
import { Page, Component as BrComponent } from '@bloomreach/spa-sdk/';
import { Subscription } from 'rxjs';
import { AnalizyRatingService } from '../services/analizy-rating.service';

@Component({
  selector: 'ft-analizy-rating',
  templateUrl: './analizy-rating.component.html',
  styleUrls: ['./analizy-rating.component.scss'],
})
export class AnalizyRatingComponent
  extends BaseProductDetailComponent
  implements OverviewDisplayComponent, OnDestroy {
  // component essentials
  dataSubscription: Subscription;

  // required properties
  effectiveDate: string;
  months12: string;
  months36: string;
  category: string;

  // image url's
  analizyLogoUrl: string;
  month12DisplayUrl: string;
  month36DisplayUrl: string;
  labels: object;

  // visibility flag
  showAnalizyRating = false;

  // labels
  titleLabel: string;
  dateLabel: string;
  categoryLabel: string;
  analizyInfoLabel: string;

  constructor(
    private analizyRatingService: AnalizyRatingService,
    private changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  populate(
    componentConfig: OverviewComponentConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ): void {
    this.initialize(brConfig, component, page);
    this.labels = page
      .getComponent('overview', 'analizy-ratings')
      .getModels()?.labels;

    if (brConfig.fundId) {
      this.dataSubscription = this.analizyRatingService.analizyRatingState.subscribe(
        (newState: AnalizyRatingState) => {
          this.mapState(newState);
          this.changeDetector.detectChanges();
        }
      );
      this.analizyRatingService.populate(brConfig);
    }
  }

  /**
   * populate all the required values for analizy rating componenet
   * @param analizyRatingState state having details for the analizy ratins
   */
  mapState(analizyRatingState: AnalizyRatingState): void {
    this.category = analizyRatingState.category;
    this.effectiveDate = analizyRatingState.effectiveDate;
    this.months12 = analizyRatingState.months12;
    this.months36 = analizyRatingState.months36;
    if (this.category) {
      this.populateUrls();
      this.populateLabels();
      this.showAnalizyRating = true;
    }
  }

  /**
   * populate Urls for displayed images dynamically
   */
  private populateUrls(): void {
    this.month12DisplayUrl = this.labels[`12M-${this.months12}`];
    this.month36DisplayUrl = this.labels[`36M-${this.months36}`];
    this.analizyLogoUrl = this.labels['analizy-logo'];
  }

  /**
   * populate requrired labels from bloomreach labels
   */
  private populateLabels(): void {
    this.titleLabel = this.labels['analizy-title'];
    this.dateLabel = this.labels['analizy-date'];
    this.dateLabel = this.dateLabel.replace(
      'effective-date',
      this.effectiveDate
    );
    this.categoryLabel = this.labels['analizy-category'];
    this.analizyInfoLabel = this.labels['analizy-info'];
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }
}
